import { createFileRoute, useLoaderData } from "@tanstack/react-router";
import { HeaderRoot, HeaderTitle } from "@/components/header";
import { Page } from "@/components/page";
import {
  PageTitleMainContent,
  PageTitleRoot,
} from "@/components/page-title/page-title-root";
import { EmptyStateV2Root } from "@/components/empty-state-v2";
import { GeneralTermsSeeLaterButton } from "@/components/general-terms/general-terms-see-later-button";
import { GeneralTermsChangeList } from "@/components/general-terms/general-terms-change-list";
import { GeneralTermsAcceptButton } from "@/components/general-terms/general-terms-accept-button";
import { getIP } from "@/lib/ip-getter";

export const GeneralTermsAndConditionsPage = (): JSX.Element => {
  const routerContext = useLoaderData({
    from: "/general-terms/",
  });

  const showSeeLaterButton = routerContext.generalTermsConfiguration.exibeVerDepois;

  return (
    <>
      <HeaderRoot>
        <HeaderTitle title="Condições Gerais" align="center" />
      </HeaderRoot>
      <Page>
        <PageTitleRoot>
          <PageTitleMainContent>
            Atualização das Condições Gerais para a Locação e Prestação de Serviços
          </PageTitleMainContent>
          <h3 className="text-neutral-500 text-sm font-normal">
            Fizemos algumas <strong>atualizações no seu contrato com a Livance</strong>{" "}
            para garantir mais transparência e alinhamento com nossos serviços. As
            principais mudanças foram:
          </h3>
        </PageTitleRoot>
        <EmptyStateV2Root className="py-6">
          <GeneralTermsChangeList />
        </EmptyStateV2Root>
        <EmptyStateV2Root className="py-4 flex flex-col gap-6 items-center">
          <GeneralTermsAcceptButton memberIP={routerContext.memberIP} />
          {showSeeLaterButton ? <GeneralTermsSeeLaterButton /> : null}
        </EmptyStateV2Root>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/general-terms/")({
  component: GeneralTermsAndConditionsPage,
  beforeLoad: ({ context }) => {
    return {
      generalTermsConfiguration: context.ldClient.getGeneralTermsConfiguration(),
    };
  },
  loader: async ({ context }) => {
    const generalTermsConfiguration = context.generalTermsConfiguration;
    const memberIP = await getIP();

    return { generalTermsConfiguration, memberIP };
  },
});
